import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';

import './AddConnectionRequest.css';

@inject('translationsStore')
@observer
export default class AddConnectionRequest extends Component
{
  render() {
    const { visible, translationsStore, onAddConnection } = this.props;
    return <Fragment>
      { !!visible &&
        <div className="AddConnectionRequest" onClick={onAddConnection}>
          <div>{ translationsStore.translate('connectionRequests.connectNewVehicles') }</div>
        </div>
      }
    </Fragment>
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ConnectionRequestsDashboard/AddConnectionRequest/AddConnectionRequest.js